export { CorporativoCard } from "./CorporativoCard";
